import { render } from "./index.vue?vue&type=template&id=cd315158&scoped=true&bindings={}"
import script from "./featured-playlists.js?vue&type=script&lang=js"
export * from "./featured-playlists.js?vue&type=script&lang=js"

import "./featured-playlists.scss?vue&type=style&index=0&id=cd315158&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd315158"

export default script